const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'emoney',
    assets: [
        {
            description: 'e-Money NGM staking token. In addition to earning staking rewards the token is bought back and burned based on e-Money stablecoin inflation.',
            denom_units: [{
                    denom: 'ungm',
                    exponent: 0
                }, {
                    denom: 'ngm',
                    exponent: 6
                }],
            base: 'ungm',
            name: 'e-Money',
            display: 'ngm',
            symbol: 'NGM',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg'
            },
            coingecko_id: 'e-money',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/ngm.svg'
                }]
        },
        {
            description: 'e-Money EUR stablecoin. Audited and backed by fiat EUR deposits and government bonds.',
            denom_units: [{
                    denom: 'eeur',
                    exponent: 0
                }, {
                    denom: 'eur',
                    exponent: 6
                }],
            base: 'eeur',
            name: 'e-Money EUR',
            display: 'eur',
            symbol: 'EEUR',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg'
            },
            coingecko_id: 'e-money-eur',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/eeur.svg'
                }]
        },
        {
            description: 'e-Money CHF stablecoin. Audited and backed by fiat CHF deposits and government bonds.',
            denom_units: [{
                    denom: 'echf',
                    exponent: 0
                }, {
                    denom: 'chf',
                    exponent: 6
                }],
            base: 'echf',
            name: 'e-Money CHF',
            display: 'chf',
            symbol: 'ECHF',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.svg'
            },
            coingecko_id: '',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/echf.svg'
                }]
        },
        {
            description: 'e-Money NOK stablecoin. Audited and backed by fiat NOK deposits and government bonds.',
            denom_units: [{
                    denom: 'enok',
                    exponent: 0
                }, {
                    denom: 'nok',
                    exponent: 6
                }],
            base: 'enok',
            name: 'e-Money NOK',
            display: 'nok',
            symbol: 'ENOK',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.svg'
            },
            coingecko_id: '',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/enok.svg'
                }]
        },
        {
            description: 'e-Money DKK stablecoin. Audited and backed by fiat DKK deposits and government bonds.',
            denom_units: [{
                    denom: 'edkk',
                    exponent: 0
                }, {
                    denom: 'dkk',
                    exponent: 6
                }],
            base: 'edkk',
            name: 'e-Money DKK',
            display: 'dkk',
            symbol: 'EDKK',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.svg'
            },
            coingecko_id: '',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/edkk.svg'
                }]
        },
        {
            description: 'e-Money SEK stablecoin. Audited and backed by fiat SEK deposits and government bonds.',
            denom_units: [{
                    denom: 'esek',
                    exponent: 0
                }, {
                    denom: 'sek',
                    exponent: 6
                }],
            base: 'esek',
            name: 'e-Money SEK',
            display: 'sek',
            symbol: 'ESEK',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.svg'
            },
            coingecko_id: '',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/emoney/images/esek.svg'
                }]
        }
    ]
};
export default info;
